import { PAYMENT_STATUS_LABELS } from "../../lib/api";

const MAP = {
  open:      { bg: "#F1F5F9", fg: "#475569", dot: "#94A3B8" },
  paid:      { bg: "#E8F5E9", fg: "#2E7D32", dot: "#2E7D32" },
  late:      { bg: "#FEE2E2", fg: "#DC2626", dot: "#DC2626" },
  checked:   { bg: "#E0F2FE", fg: "#0369A1", dot: "#0EA5E9" },
  released:  { bg: "#FEF3C7", fg: "#92400E", dot: "#D4AF37" },
  cancelled: { bg: "#F1F5F9", fg: "#94A3B8", dot: "#94A3B8" },
};

export function StatusBadge({ status }) {
  const s = MAP[status] || MAP.open;
  return (
    <span
      data-testid={`status-${status}`}
      className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
      {PAYMENT_STATUS_LABELS[status] || status}
    </span>
  );
}
